/**
 * BoardV3 Snap Indicator
 * Shows where task will drop during drag
 */

import { memo } from 'react';
import { useColumnYOffsets, useRowHeight, useDayWidth, useHeaderHeight } from './BoardLayoutContext';

interface BoardV3SnapIndicatorProps {
  column: string;
  day: number;
  duration: number;
}

export const BoardV3SnapIndicator = memo(function BoardV3SnapIndicator({
  column,
  day,
  duration,
}: BoardV3SnapIndicatorProps) {
  const columnYOffsets = useColumnYOffsets();
  const rowHeight = useRowHeight();
  const dayWidth = useDayWidth();
  const headerHeight = useHeaderHeight();

  const yOffset = columnYOffsets[column] ?? 0;
  const x = day * dayWidth;
  const y = headerHeight + yOffset;
  const width = duration * dayWidth;

  return (
    <div
      style={{
        position: 'absolute',
        left: x,
        top: y,
        width,
        height: rowHeight,
        backgroundColor: 'rgba(59, 130, 246, 0.15)',
        border: '2px dashed #3b82f6',
        borderRadius: 4,
        pointerEvents: 'none',
        zIndex: 5,
      }}
    />
  );
});
